export default __webpack_public_path__ + "static/media/avatar12-mujer.d06cd548.png";